"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.copy = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const copy = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'copy-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M14.5556 6.5H8.44444C7.87491 6.5 7.5 6.93379 7.5 7.36364V15.6364C7.5 16.0662 7.87491 16.5 8.44444 16.5H14.5556C15.1251 16.5 15.5 16.0662 15.5 15.6364V7.36364C15.5 6.93379 15.1251 6.5 14.5556 6.5ZM8.44444 5C7.09442 5 6 6.05824 6 7.36364V15.6364C6 16.9418 7.09441 18 8.44444 18H14.5556C15.9056 18 17 16.9418 17 15.6364V7.36364C17 6.05824 15.9056 5 14.5556 5H8.44444Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M3.21967 2.21967C3.36032 2.07902 3.55109 2 3.75001 2L10.7503 2.00009C11.1645 2.00009 11.5003 2.33588 11.5003 2.75009C11.5003 3.16431 11.1645 3.50009 10.7503 3.50009L4.50002 3.50001L4.5002 11.25C4.50021 11.6642 4.16443 12 3.75022 12C3.336 12 3.00021 11.6642 3.0002 11.25L3 2.75002C3 2.5511 3.07901 2.36033 3.21967 2.21967Z', fill: '#4B5563' })));
};
exports.copy = copy;
